import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { HelpdeskContext } from './Helpdesk';
import InfiniteScroll from "react-infinite-scroll-component";
import jwt from 'jwt-decode'


function FilterBody() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateHelpdesk, dispatchHelpdesk } = useContext(HelpdeskContext);

    const handleClick = (id) => {
        dispatchHelpdesk({
            type: "ACTIVE",
            active: id,
        })
    }

    const fetchMoreData = () => {
        dispatchHelpdesk({
            type: "TRIGGER",
            trigger: { message: 'reload-chats' }
        })
    }

    useEffect(() => {
        if (stateHelpdesk.trigger.message == 'helpdesk-chat-admin' && stateHelpdesk.trigger.data === 'success') {
            let cleanFilter = stateHelpdesk.chats
            const index = cleanFilter.findIndex(chat => chat.complaint_id == stateHelpdesk.trigger.action.data.input.parent_chat)
            if (cleanFilter[index] != undefined) {

                const statusNew = stateHelpdesk.filterSub == 'new' && (stateHelpdesk.trigger.action.name != 'new-list-message' || stateHelpdesk.trigger.action.data.input.chat_type.sender == 'admin')
                const statusProcess = stateHelpdesk.filterSub == 'process' && stateHelpdesk.trigger.action.data.input.chat_type.sender == 'user'
                const statusPanding = stateHelpdesk.filterSub == 'panding' && stateHelpdesk.trigger.action.data.input.chat_type.sender == 'admin'
                const mine = stateHelpdesk.filterSub == 'mine' && stateHelpdesk.trigger.action.data.input.basic.admin != jwt(localStorage.getItem('token-helpdesk-umy')).user
                const other = stateHelpdesk.filterSub == 'other' && stateHelpdesk.trigger.action.data.input.basic.admin == jwt(localStorage.getItem('token-helpdesk-umy')).user
                if (statusNew || statusProcess || statusPanding || mine || other) {
                    cleanFilter.splice(index, 1)
                    dispatchHelpdesk({
                        type: 'ACTIVE',
                        active: null
                    })
                } else {
                    cleanFilter[index].content = stateHelpdesk.trigger.action.data.input.message
                    cleanFilter[index].admin = stateHelpdesk.trigger.action.data.input.chat_type.sender == 'user' ? cleanFilter[index].admin : stateHelpdesk.trigger.action.data.input.username
                    cleanFilter[index].status = (stateHelpdesk.trigger.action.data.input.chat_type.sender == 'admin' ? 1 : 4)
                    cleanFilter[index].time = stateHelpdesk.trigger.action.data.input.time

                    cleanFilter = cleanFilter.sort((a, b) => b.time.localeCompare(a.time))
                }
                dispatchHelpdesk({
                    type: 'CHATS',
                    payload: cleanFilter
                })
                dispatchHelpdesk({
                    type: "TRIGGER",
                    trigger: { message: 'reload-filter-body' }
                })
            } else {
                const all = stateHelpdesk.filter == 'all'
                const statusNew = stateHelpdesk.filterSub == 'new' && stateHelpdesk.trigger.action.data.input.chat_type.sender == 'user'
                const statusProcess = stateHelpdesk.filterSub == 'process' && stateHelpdesk.trigger.action.data.input.chat_type.sender == 'admin' && (stateHelpdesk.trigger.action.name == 'message' || stateHelpdesk.trigger.action.name == 'attachment')
                const mine = stateHelpdesk.filterSub == 'mine' && stateHelpdesk.trigger.action.data.input.basic.admin == jwt(localStorage.getItem('token-helpdesk-umy')).user
                const other = stateHelpdesk.filterSub == 'other' && stateHelpdesk.trigger.action.data.input.basic.admin != jwt(localStorage.getItem('token-helpdesk-umy')).user
                if (all || statusNew || statusProcess || mine || other) {
                    const newChat = {
                        complaint_id: stateHelpdesk.trigger.action.data.action.parent.id,
                        category_id: (statusProcess) ? stateHelpdesk.trigger.action.data.input.basic.category_id : stateHelpdesk.trigger.action.data.input.category,
                        employee_id: stateHelpdesk.trigger.action.data.input.profile.status == 'student' ? null : stateHelpdesk.trigger.action.data.input.profile.id,
                        nim: stateHelpdesk.trigger.action.data.input.profile.status == 'student' ? stateHelpdesk.trigger.action.data.input.profile.id : null,
                        content: stateHelpdesk.trigger.action.data.input.message,
                        admin: stateHelpdesk.trigger.action.data.input.basic.admin,
                        status: stateHelpdesk.trigger.action.name == 'new-list-message' || stateHelpdesk.trigger.action.data.input.chat_type.sender == 'user' ? 4 : 1,
                        username: (statusProcess) ? stateHelpdesk.trigger.action.data.input.basic.username : stateHelpdesk.trigger.action.data.input.username,
                        time: stateHelpdesk.trigger.action.data.input.time
                    }

                    cleanFilter = cleanFilter.concat(newChat)
                    cleanFilter = cleanFilter.sort((a, b) => b.time.localeCompare(a.time))
                    dispatchHelpdesk({
                        type: 'CHATS',
                        payload: cleanFilter
                    })
                }

                dispatchHelpdesk({
                    type: "TRIGGER",
                    trigger: { message: 'reload-filter-body' }
                })
            }
        } else if (stateHelpdesk.trigger.message == 'helpdesk-user-feedback' && stateHelpdesk.trigger.data === 'success') {
            let cleanFilter = stateHelpdesk.chats
            const index = cleanFilter.findIndex(chat => chat.complaint_id == stateHelpdesk.trigger.action.data.chat_id)
            if (cleanFilter[index] != undefined) {
                if (stateHelpdesk.trigger.action.name == 'close' || (stateHelpdesk.filterSub == 'new' && stateHelpdesk.trigger.action.data.status_id != '4') || (stateHelpdesk.filterSub == 'panding' && stateHelpdesk.trigger.action.data.status_id != '2') || (stateHelpdesk.filterSub == 'process' && stateHelpdesk.trigger.action.data.status_id != '1')) {
                    //delete
                    cleanFilter.splice(index, 1)
                    dispatchHelpdesk({
                        type: 'ACTIVE',
                        active: null
                    })
                } else if (stateHelpdesk.trigger.action.name == 'update') {
                    //update
                    cleanFilter[index].status = stateHelpdesk.trigger.action.data.status_id
                    cleanFilter[index].admin = stateHelpdesk.trigger.action.data.admin == null ? cleanFilter[index].admin : stateHelpdesk.trigger.action.data.admin
                }
                dispatchHelpdesk({
                    type: 'CHATS',
                    payload: cleanFilter
                })
                dispatchHelpdesk({
                    type: "TRIGGER",
                    trigger: { message: 'reload-filter-body' }
                })
            } else if ((stateHelpdesk.filterSub == 'new' && stateHelpdesk.trigger.action.data.status_id == '4') || (stateHelpdesk.filterSub == 'panding' && stateHelpdesk.trigger.action.data.status_id == '2') || (stateHelpdesk.filterSub == 'process' && stateHelpdesk.trigger.action.data.status_id == '1')) {
                let newChat = stateHelpdesk.trigger.action.data.user
                newChat.status = stateHelpdesk.trigger.action.data.status_id
                newChat.admin = stateHelpdesk.trigger.action.data.admin
                newChat = stateHelpdesk.chats.concat(newChat).sort((a, b) => b.time.localeCompare(a.time))
                dispatchHelpdesk({
                    type: 'CHATS',
                    payload: newChat
                })
            }
        }
    }, [stateHelpdesk.trigger])

    const [tempChats, settempChats] = useState([])

    useEffect(() => {
        settempChats(stateHelpdesk.chats)
    }, [stateHelpdesk.chats])

    const initialState = (
        <div className="card-body">
            <div className="empty-state" data-height="400">
                <div className="empty-state-icon">
                    <i className="fas fa-question"></i>
                </div>
                <h2>We couldn't find any data</h2>
                <p className="lead">
                    Sorry we can't find any data, to get rid of this message, make at least 1 entry.
                </p>
            </div>
        </div>
    )
    const [renderChat, setrenderChat] = useState(initialState)

    useEffect(() => {
        if (tempChats.length > 0 || stateHelpdesk.trigger == 'reload-filter-body') {
            setrenderChat(
                <Fragment>
                    <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', }}>
                        <InfiniteScroll
                            dataLength={tempChats.length}
                            next={fetchMoreData}
                            hasMore={true}
                            // loader={<h4>{''}</h4>}
                            endMessage={
                                <p style={{ textAlign: "center" }}>
                                    <b>Yay! You have seen it all</b>
                                </p>
                            }
                            scrollableTarget="scrollableDiv"
                        >
                            {tempChats.map((chat) =>
                                <div key={chat.complaint_id} onClick={() => handleClick(chat.complaint_id)} >
                                    <div className={`ticket-item pr-2 pt-3 pl-2 pb-1 ${stateHelpdesk.active == chat.complaint_id ? `active` : ''}`}>
                                        <div className="row col-12 pr-1" >
                                            <div className="col-auto">
                                                <div className="avatar-item">
                                                    <img alt="image" src="../assets/img/avatar/avatar-1.png" className="img-fluid pr-0" width="40" data-toggle="tooltip" title={`${chat.username}`} />
                                                    {chat.admin != null ? (<div className="avatar-badge" title={chat.admin} data-toggle="tooltip"><img src="../assets/img/avatar/avatar-3.png" width="20" alt="" /></div>) : ''}
                                                </div>
                                            </div>
                                            <div className="media-body col-mx-auto  pl-0 ml-0 mr-0 pr-0">
                                                <div className="ticket-title mb-0 pb-0">
                                                    <h4 style={{ fontWeight: 'bolder', fontSize: '13px', marginBottom: '0px' }}>{chat.username}  {(chat.status == 4 || chat.status == 2) ? (<i data-toggle="tooltip" title={chat.status == 4 ? 'New Message' : 'Pending'} className={`fas fa-comment-alt text-${chat.status == 4 ? 'danger' : 'warning'}`} style={{ fontSize: '20px', float: 'right', textShadow: '-1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff' }}> </i>) : ''} </h4>
                                                </div>
                                                <div className="ticket-desc mb-0  pb-0">
                                                    <div className="mb-0"><p style={{ fontSize: '11px', marginBottom: '0px' }}>{`${new Date(chat.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').substring(0, new Date(chat.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').length - 3)}`}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </InfiniteScroll>
                    </div>
                </Fragment>
            )
        }
        else {
            setrenderChat(
                <div className="card-body">
                    <div className="empty-state" data-height="400">
                        <div className="empty-state-icon">
                            <i className="fas fa-envelope-open-text"></i>
                        </div>
                        <h2>No New Messages</h2>
                        <p className="lead">
                            All messages have been replied to.
                        </p>
                    </div>
                </div>
            )
        }
    }, [tempChats, stateHelpdesk.trigger, stateHelpdesk.active])

    //loading
    useEffect(() => {
        if (stateHelpdesk.trigger.message == "get-chat-load") {
            setrenderChat(
                <div className="card-body">
                    <div className="empty-state" data-height="400">
                        <div className="empty-state-icon">
                            <i className="fas fa-spinner fa-pulse"></i>
                        </div>
                        <h2>Get Chat</h2>
                        <p className="lead">
                            ... loading
                        </p>
                    </div>
                </div>
            )
        } else if (stateHelpdesk.trigger.message == "get-chat-category") {
            setrenderChat(
                <div className="card-body">
                    <div className="empty-state" data-height="400">
                        <div className="empty-state-icon">
                            <i className="fas fa-spinner fa-pulse"></i>
                        </div>
                        <h2>... loading</h2>
                        <p className="lead">
                            Choose Category
                        </p>
                    </div>
                </div>
            )
        }
    }, [stateHelpdesk.trigger])

    return (
        <div className="card-body chat-content-chat pl-0 pr-2 overflow-auto" >
            {renderChat}
        </div>
    )
}

export default FilterBody
